import { useQuery, keepPreviousData, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";
import handleError from "@lib/helpers/handleError";
import buildListUrl from "@lib/shared/queryString";

const DEFAULT_SORT = {
  property: "updated_at",
  direction: "desc",
};

export default function useContacts({
  page = 1,
  sortBy = DEFAULT_SORT,
  search = "",
  filters = [],
}) {
  const api = useAxios();
  const client = useQueryClient();

  const url = buildListUrl(
    "/contacts",
    { page, sortBy: sortBy.property, sortDirection: sortBy.direction, search },
    filters
  );

  // note isFetching is available to show a loading indicator while loading new data
  const { isPending, isFetching, error, data, isPlaceholderData } = useQuery({
    queryKey: ["contacts", page, sortBy, search, filters],
    queryFn: () => api.get(url),
    placeholderData: keepPreviousData,
  });

  handleError(error);

  const invalidate = () => {
    client.invalidateQueries({ queryKey: ["contacts"] });
  };

  const lastPage = data?.data.meta.last_page ?? 0;
  const total = data?.data.meta.total ?? 0;
  const from = data?.data.meta.from ?? 0;
  const to = data?.data.meta.to ?? 0;
  const contacts = data?.data.data ?? [];
  const hasMore = (data?.data.meta.last_page > page ?? false) && !isPlaceholderData;

  return {
    contacts,
    lastPage,
    total,
    from,
    to,
    hasMore,
    contactsIsLoading: isPending,
    contactsIsFetching: isFetching,
    invalidate,
  };
}